import stringIsEmail from 'validator/lib/isEmail';

export const isPlateNumber = input => {
  return (
    input.match('^[0-9A-Z]{2}-[0-9A-Z]{2}$') !== null ||
    input.match('^[0-9A-Z]{2}-[0-9A-Z]{3}$') !== null ||
    input.match('^[0-9A-Z]{2}-[0-9A-Z]{4}$') !== null ||
    input.match('^[0-9A-Z]{3}-[0-9A-Z]{2}$') !== null ||
    input.match('^[0-9A-Z]{3}-[0-9A-Z]{3}$') !== null ||
    input.match('^[0-9A-Z]{3}-[0-9A-Z]{4}$') !== null ||
    input.match('^[0-9A-Z]{4}-[0-9A-Z]{2}$') !== null
  );
};

export const isPhoneNumber = input => {
  return input.match('09[0-9]{8}');
};

export const isOtpCode = input => {
  return input.match('[0-9]{6}');
};

export const isEmail = input => {
  return stringIsEmail(input);
};

export const isCreditCardCVC = input => {
  return input.match('[0-9]{3}');
};

export const isCreditCardPan = input => {
  return input.match('[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}');
};

export const isCreditCardExpireDate = input => {
  return input.match('(([0-1]{1}[0-2]{1})|(0[1-9]{1}))/[0-3]{1}[0-9]{1}');
};

export const isReceiptCarrierCitizenDigitalNumber = input => {
  return input.match('[A-Z]{2}[0-9]{14}');
};

export const isReceiptCarrierMobileBarcode = input => {
  return input.match(`^/[0-9A-Z+-.]{7}$`);
};

export const isReceiptB2b = input => {
  return input.match('[0-9]{8}');
};

// 密碼僅允許 ASCII code 的字元
export const PASSWORD_CHAR_REGEX = '[\x00-\x7F]';
